import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M12.9998798,2.02431234 C13.5521646,2.02431234 13.9998798,2.47202759 13.9998798,3.02431234 L13.9998798,3.02431234 L13.9998798,13.0243123 C13.9998798,13.5765971 13.5521646,14.0243123 12.9998798,14.0243123 L12.9998798,14.0243123 L2.99987984,14.0243123 C2.44759509,14.0243123 1.99987984,13.5765971 1.99987984,13.0243123 L1.99987984,13.0243123 L1.99987984,3.02431234 C1.99987984,2.47202759 2.44759509,2.02431234 2.99987984,2.02431234 L2.99987984,2.02431234 Z M8.70887687,5 L6,5 L6,6.63697105 L7.07286032,6.63697105 L7.07286032,11 L8.70887687,11 L8.70887687,5 Z"
        fill-opacity=".9"
        fill-rule="evenodd"
      />
    </svg>
  )
}
const FontH1Icon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontH1Icon
